import React from 'react'

const Logout = () => {
    const redirectUrl = `${process.env.REACT_APP_Auth_WEB_BASE_URL}/logout`;

    const logoutHandler = async() => {
        const preferredLang = localStorage.getItem('preferredLang') || localStorage.getItem('i18nextLng') || localStorage.getItem('appLang');
        await localStorage.clear();
        if (preferredLang) {
            localStorage.setItem('preferredLang', preferredLang);
        }
        window.location.assign(redirectUrl);
    }

    logoutHandler();

    return (
        <div>Logout...</div>
    )
}

export default Logout
